import { combineReducers, configureStore } from "@reduxjs/toolkit";
import loginReducer from "./slices/loginSlice";
import authCodeReducer from "./slices/authSlice";
import logoutReducer from "./slices/logoutSlice";
import sellerTrackingReducer from "./slices/sellerTrackingSlice";
import addPriceAlertReducer from "./slices/addPriceAlertSlice";
import priceAlertInfoReducer from "./slices/priceAlertInfoSlice";
import asinWatchlistReducer from "./slices/asinWatchlistSlice";
import blacklistReducer from "./slices/blacklistSlice";

const rootReducer = combineReducers({
  login: loginReducer,
  auth: authCodeReducer,
  logout: logoutReducer,
  sellerTracking: sellerTrackingReducer,
  addPriceAlert: addPriceAlertReducer,
  priceAlertInfo: priceAlertInfoReducer,
  asinWatchlist: asinWatchlistReducer,
  blacklist: blacklistReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
